//#region src/components/ScalarCombobox/filter-by-option-label.ts
var filterByOptionLabel = ((query, options) => {
	return query === "" ? options : options.filter((option) => {
		return option.label.toLowerCase().includes(query.toLowerCase());
	});
});
//#endregion
export { filterByOptionLabel };

//# sourceMappingURL=filter-by-option-label.js.map